import PropTypes from "prop-types";

const propTypes = {
  /**
   * The tab's id
   */
  id: PropTypes.number.isRequired,

  /**
   * This value stores which tabs is active
   */
  activeTab: PropTypes.number.isRequired,

  /**
   * This prop handles what to render
   */
  content: PropTypes.object.isRequired,
};

const DirectoryTabContent = ({ id, activeTab, content }) => {
  return (
    <section
      role="tabpanel"
      id={`tabpanel_${id}`}
      aria-labelledby={`tab_${id}`}
      aria-label="tab_content"
      css={{ display: activeTab === id ? "block" : "none" }}
    >
      {content}
    </section>
  );
};

DirectoryTabContent.propTypes = propTypes;

export default DirectoryTabContent;
